exports.map_info_overlay = require('./map_info_overlay.hbs')
exports.text_below_search_input = require('./partials/text_below_search_input.hbs')
